import { PropsWithChildren, useState } from "react";
import { FormattedMessage } from "react-intl";

import RequiredFieldIndicator from "@components/fields/RequiredFieldIndicator";
import styles from "@components/fieldsNative/Checkbox.module.css";
import FormError from "@components/typography/FormError";
import { clickCurrentTarget } from "@utils/keyboardUtils";

type Props = PropsWithChildren<{
  checked: boolean;
  error: string | null | undefined;
  name: string;
  required?: boolean;
  setValue: (value: boolean) => void;
}>;

const Checkbox = ({ checked, children, error, name, required = false, setValue }: Props) => {
  const onKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    clickCurrentTarget(e);
  };

  const [inputFocused, setInputFocused] = useState(false);

  return (
    <div>
      <label className={styles.checkmarkContainer} data-test="toggle-checkbox">
        <input
          checked={checked}
          data-test="checkbox"
          name={name}
          onBlur={() => setInputFocused(false)}
          onChange={e => setValue(e.target.checked)}
          onFocus={() => setInputFocused(true)}
          onKeyUp={onKeyUp}
          type="checkbox"
        />
        <span
          className={`${styles.checkmark} ${inputFocused ? styles.focus : ""}`}
          data-test="interactive-checkbox"
        ></span>
        {children}
        {required && <RequiredFieldIndicator />}
      </label>
      {error && (
        <div>
          {error && (
            <div className={styles.error}>
              <FormError>
                <FormattedMessage id={error} />
              </FormError>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Checkbox;
